import React from 'react';
import { parseDomain } from '@wix/domains-serverless-interface';
import { PerceptionNote } from './PerceptionNote';
import { PerceptionNotePlaceholder } from './PerceptionNotePlaceholder';
export const PerceptionCardNote = _ref => {
  let {
    row,
    domain,
    bulletAligned = false,
    size = 'medium'
  } = _ref;
  const {
    tld
  } = parseDomain(domain);
  if (!row.cardNote) {
    return row.claimPending ? /*#__PURE__*/React.createElement(PerceptionNotePlaceholder, {
      size: size
    }) : null;
  }
  return /*#__PURE__*/React.createElement(PerceptionNote, {
    labelKey: row.cardNote.labelKey,
    values: {
      tld: `.${tld}`
    },
    withIcon: row.cardNote.withIcon,
    size: size,
    variant: bulletAligned ? 'bullet' : 'inline',
    dataHook: "price-card-note"
  });
};
//# sourceMappingURL=PerceptionCardNote.js.map